var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div flex=\"100\"><list-header></list-header><table class=\"table table-responsive\"><colgroup><col span=\"1\"/><col span=\"1\"/><col span=\"1\" class=\"tableNav\"/></colgroup><thead><th>Menu</th><th>Description</th><th class=\"text-right\"><button ng-click=\"vm.addItemDialog()\" class=\"btn btn-primary btn-xs\">{{::vm.constructorArgs.addHeaderText}}</button></th></thead><tbody><tr ng-repeat=\"item in vm.items | filter:searchText | orderBy:vm.sortOrder\"><td> <button ng-click=\"vm.details(item._id)\" class=\"textonlyblue\">{{::item.name}}</button></td><td>{{::item.description}}</td><td style=\"padding: 4px;\"><list-item-buttons id-val=\"item._id\" delete-fn=\"vm.deleteItem(idVal)\" edit-fn=\"vm.details(idVal)\"></list-item-buttons></td></tr></tbody></table></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menus/menus-list.jade
// module id = 195
// module chunks = 0